import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// Lynn & Liana Designs — New-customers campaign (adc_prfj75j8pk). Lifetime
// aggregates from ANALYTICS.ADS.CAMPAIGN_PERIODS over complete months
// Nov 2025 – Aug 2026. Monthly series lives in realBrandData.ts.
//
// `monthlyBudgetDollars` is the shared $3,000 pool; the advertiser is POOLED, so
// AD_CAMPAIGNS reports no per-campaign budget. `cpaDollars` is the campaign's
// target CPA ($90.86), not a realized cost per acquisition.
export const campLlNew: FaireAdCampaignEntity = {
  token: "camp_ll_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_lynn_liana",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 3000,
  startedRunningAt: "2026-07-14",
  segmentMetrics: {
    numCustomersAcquired: 112,
    salesDollars: 56423,
    totalAdsSpendDollars: 15102,
    cpaDollars: 91,
    bestEstimateSalesDollars: 102435,
    bestEstimateRoas: 6.78,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-23T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
